import { createFileRoute } from "@tanstack/react-router";
import RedirectManager from "@/pages/admin/RedirectManager";

export const Route = createFileRoute("/admin/redirects")({
  component: RedirectManager,
});
